<template>
  <div class="table-heading">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TableHeading',
};
</script>

<style lang="scss">
.table-heading:not(.table-heading--new) {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: rem(15);

  .table-search {
    @media only screen and (max-width: $--breakpoint-sm - 1) {
      margin-top: rem(20);
      width: 100%;
    }
  }

  .el-button:first-child {
    @media only screen and (max-width: $--breakpoint-sm - 1) {
      margin-bottom: rem(20);
      width: 100%;
    }
  }

  .el-dropdown {
    @media only screen and (max-width: $--breakpoint-sm - 1) {
      margin: auto;
      width: 100%;
      .el-button {
        width: 100%;
      }
    }
  }

  .invoice-search {
    @media only screen and (max-width: $--breakpoint-sm - 1) {
      width: 100%;
    }

    @media only screen and (width <= 540px) {
      flex-direction: column;
    }

    @media only screen and (width <= 1069px) {
      margin-top: 10px;
    }
  }

  .el-switch {
    @media only screen and (max-width: $--breakpoint-sm - 1) {
      margin-right: 0;
      width: 100%;
      margin-bottom: rem(20);
      margin-top: 0;
    }
  }

  .search-input {
    .el-input__inner {
      @media only screen and (width <= 540px) {
        border-radius: 4px 4px 0 0 !important;
      }
    }
  }

  .search-button {
    @media only screen and (width <= 540px) {
      border-radius: 0 0 4px 4px !important;
    }
  }
}

// Rename to .table-heading, after refactor all tables

.table-heading--new {
  display: flex;
  flex-direction: column;
}
</style>
